import React from 'react'

const Fifty_Nine = () => {
    return (
        <div className='container'>
            <h1>Reverse an array using Recurssion</h1>
            <p>
            Write a C, C++ program to reverse an array using recursion. Given an input array, we have to write a <br /> code that reverse an array using recursion. <br />
            // Input array <br />
            <br />
int arr[] =&#123;3,2,1,7,8&#125;<br />
<br />
// Reverse of an input array<br />
<br />
arr[] =&#123;8,7,1,2,3&#125;<br />
           
        </p>
        <div className='containers'>
       <code className='library'>#include</code>  &lt;stdio.h&gt;  <br />
 
  <code className='comment'>// Function to print contents of an array</code><br />
  <code className='keywords'></code>void print(int arr[], int n)<br />
 &#123;<br />
 <code className='keywords'> for</code> (int i = 0; i &lt; n; i++) &#123;<br />
 <code className='library'>  printf</code>("%d ", arr[i]);<br />
     &#125;<br />
 &#125;<br />
  
 <code className='comment'>// Recursive function to reverse elements of a subarray formed<br />
// by `arr[low, high]`</code><br />
 <code className='keywords'>void </code>reverse(int arr[], int low, int high)<br />
 &#123;<br />
 <code className='keywords'>  if</code> (low &lt; high)<br /><br />
     &#123;<br />
     <code className='keywords'> int</code> temp = arr[low];<br />
      arr[low] = arr[high];<br />
      arr[high] = temp;<br />
  
         reverse(arr, low + 1, high - 1);<br />
     &#125;<br />
 &#125;<br />
 <br />
 <code className='keywords'>int </code>main(void)<br />
 &#123;<br />
 <code className='keywords'>  int</code> arr[] = &#123; 1, 2, 3, 4, 5 &#125;<br />
 <code className='keywords'> int </code>n = sizeof(arr)/sizeof(arr[0]);<br />
  
     reverse(arr, 0, n - 1);<br />
     print(arr, n);<br />
  
     <code className='library'>  return</code> 0;<br />
 &#125;<br />
        </div>
        </div>
    )
}

export default Fifty_Nine
